import type { ErrorKind } from '../error-kind'

/** Opening a domain failed. `kind` says whether it is unavailable to the user or the request failed. */
export class AccessSwitchError extends Error {
    public constructor(
        public readonly kind: ErrorKind,
        public readonly cause: unknown,
    ) {
        super(cause instanceof Error ? cause.message : `The domain could not be opened (${kind})`)
        this.name = 'AccessSwitchError'
        Object.setPrototypeOf(this, new.target.prototype)
    }
}
